import { svgIcon } from "@bitwarden/components";

export const CarouselIcon = svgIcon`
  <svg class="tw-block" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="inactive-carousel-icon">
    <rect stroke="currentColor" x="0.5" y="0.5" width="11" height="11" rx="5.5" />
  </svg>
`;
